import { render, staticRenderFns } from "./UpsellEditFooter.vue?vue&type=template&id=ea085f8c&"
import script from "./UpsellEditFooter.vue?vue&type=script&lang=js&"
export * from "./UpsellEditFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports